import http from './http';
import { wOrgIdMiddleware } from '../utils/commonUtils';
import { CREATED, OK } from '../utils/constant';

const AuthorizationTreatmentService = {
  Print: wOrgIdMiddleware(async (url,id) => {
    try {
      const response = await http.GET(`${url}authorization-treatment/print/${id}`);
      console.log("rep",response);
      
      if (response.code === 200 && response.data) {
        return response.data;
      } else {
        return null;
      }

    } catch (error) {      
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      console.error('Error fetching :', error);
      throw error;
    }
  }),
  GetById : wOrgIdMiddleware(async (url,id) => {
    try {
      const response = await http.GET(`${url}authorization-treatment/${id}`);
      console.log("rep",response);
      
      if (response.code === 200 && response.data) {
        return response.data;
      } else {
        return null;
      }

    } catch (error) {      
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      console.error('Error fetching :', error);
      throw error;
    }
  }),

  //Save 
   Save: wOrgIdMiddleware(async (url,data) => {
    try {
      const response = await http.POST(`${url}authorization-treatment`, data);
      if ((response.code === OK || response.code === CREATED) && response.data) {
        return response;
      } else {
        return response;
      }

    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      console.error('Error fetching cpt:', error);
      throw error;
    }
  }),
  //Update 
  Update: wOrgIdMiddleware(async (url,id, data) => {
    try {
      const response = await http.PUT(`${url}authorization-treatment/${id}`, data);
      if (response.code === 200 && response.data) {
        return response;
      } else {
        return response;
      }

    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      console.error('Error fetching cpt:', error);
      throw error;
    }
  }),
  //Delete Cpt
  deleteCpt: async (id) => {
    try {
      const response = await http.DELETE(`cpt/${id}`);
      return response;
    } catch (error) {
      if (error.status) {
        const resData = error.data;
        if (resData.code && resData.data) {
          return resData;
        }
      }
      console.error('Error fetching cpt:', error);
      throw error;
    }
  },
    


};

export default AuthorizationTreatmentService;